// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const HighPriorityIcon = createSvgIcon(
  <svg width={24} height={24} fill="currentColor" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      d="M10.09 6.22h-.15a6.94 6.94 0 0 0 0 13.87h1.76a.65.65 0 0 0 0-1.3H9.94a5.64 5.64 0 0 1 0-11.27h.24l-1.2 1.2a.65.65 0 0 0 .92.91l2.26-2.26a.65.65 0 0 0 0-.92L9.9 4.2a.65.65 0 0 0-.92 0 .65.65 0 0 0 0 .92zm5.33 1.3a.65.65 0 0 1 0-1.3h4.08a.65.65 0 1 1 0 1.3zm0 3.15a.65.65 0 0 1 0-1.3h4.08a.65.65 0 0 1 0 1.3zm0 3.14a.65.65 0 0 1 0-1.3h4.08a.65.65 0 1 1 0 1.3zm0 3.14a.65.65 0 0 1 0-1.3h4.08a.65.65 0 1 1 0 1.3zm0 3.15a.65.65 0 0 1 0-1.3h4.08a.65.65 0 0 1 0 1.3z"
      clipRule="evenodd"
    />
  </svg>,
  "HighPriority",
);
export default HighPriorityIcon;
